import { Box, styled } from '@mui/material';

export const ErrorNoDataStyled = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    // height: 'calc(100vh - 64px)',
    width: '100%',
});
